const SabaIslandSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112227)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M20 7.40903e-06C19.9813 -0.0140551 -0.00531144 19.9948 1.05887e-06 20C1.05887e-06 8.95438 8.95437 7.40903e-06 20 7.40903e-06Z"
        fill="#D80027"
      />
      <path
        d="M20 7.40906e-06C20.0187 -0.0140551 40.0053 19.9947 40 20C40 8.95438 31.0456 7.40906e-06 20 7.40906e-06Z"
        fill="#D80027"
      />
      <path
        d="M20 40C19.9813 40.0141 -0.00531144 20.0053 1.05887e-06 20C1.05887e-06 31.0456 8.95437 40 20 40Z"
        fill="#0052B4"
      />
      <path
        d="M20 40C20.0187 40.0141 40.0053 20.0053 40 20C40 31.0456 31.0456 40 20 40Z"
        fill="#0052B4"
      />
      <path
        d="M20.0001 10.4346L22.1585 17.0775H29.1433L23.4924 21.1829L25.6508 27.8259L20.0001 23.7204L14.3493 27.8259L16.5077 21.1829L10.8569 17.0775H17.8416L20.0001 10.4346Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112227">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SabaIslandSvg;
